// Copyright aptihealth, inc. 2019 All Rights Reserved
import React, { Component } from "react";
import { Form } from "formik";
import {
    BASIC_SCHEMA,
    PATIENT_BASIC_SCHEMA,
    PREFERRED_NAME_SCHEMA_PATIENT,
} from "../../../containers/Dashboard/Patient/schema/PatientProfileInfoSchema";
import FormikInput from "../../UI/FormikInput";
import PatientProfileDetailsCard from "./PatientProfileDetailsCard";
import {
    PATIENT_VALIDATION_SCHEMA,
    VALIDATION_SCHEMA,
} from "../../../containers/Dashboard/Patient/schema/PatientProfileValidation";
import { renderTitleWithValue } from "./index";
import SubmitControls from "./SubmitControls";
import Hr from "../../UI/Hr";
import FormikMobileInput from "../../UI/formikMobileInput";
import { isUserAdmin, isUserPatient } from "../../../redux/actions/auth";
import { CustomForm } from "../../../component-library/CustomForm";

class ProfileBasicInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editableData: null,
            edit: props.edit,
        };
    }

    componentDidMount() {
        let profileData = this.props.data;
        if (isUserAdmin()) {
            profileData = this.trasformDOBsToValidStrings(profileData);
        }

        this.setState({
            editableData: profileData,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps != this.props) {
            let profileData = this.props.data;
            if (isUserAdmin()) {
                profileData = this.trasformDOBsToValidStrings(profileData);
            }

            this.setState({
                editableData: profileData,
            });
        }
    }

    toggleEditBasicInfo = () => {
        this.setState((ps) => {
            return {
                edit: !ps.edit,
            };
        });
    };

    renderBasicForm = (formikProps) => {
        let schema = PATIENT_BASIC_SCHEMA;

        if (!isUserPatient()) {
            schema = BASIC_SCHEMA;
        }

        return (
            <Form>
                <div className="mx-auto px-0 ">
                    <div className="container px-0">
                        <div className="row">
                            {schema.map((formEl) => {
                                if (formEl.elementType === "segment") {
                                    return (
                                        <h6 key={formEl.displayName} className="col-12">
                                            <b>{formEl.displayName}</b>
                                        </h6>
                                    );
                                } else if (formEl.elementType === "readOnly") {
                                    return (
                                        <div key={formEl.name} className={"col-12 col-lg-6"}>
                                            <FormikInput
                                                disabled
                                                inputBorderDisabled="border-0 px-0"
                                                formEl={formEl}
                                                errors={formikProps.errors}
                                                touched={formikProps.touched}
                                            />
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div key={formEl.name} className="col-12 col-lg-6">
                                            {formEl.name === "email" && this.state.edit ? (
                                                <FormikInput
                                                    disabled
                                                    inputBorderDisabled="border-0 px-0"
                                                    formEl={formEl}
                                                    errors={formikProps.errors}
                                                    touched={formikProps.touched}
                                                />
                                            ) : formEl.name == "mobile" ? (
                                                <FormikMobileInput
                                                    value={formikProps && formikProps.values.mobile}
                                                    onChange={async (val) => {
                                                        await formikProps.setFieldValue(
                                                            "mobile",
                                                            val.value,
                                                        );
                                                        formikProps.setFieldTouched("mobile");
                                                    }}
                                                    formEl={formEl}
                                                    errors={formikProps.errors}
                                                    touched={formikProps.touched}
                                                />
                                            ) : formEl.name == "dob" ? (
                                                <FormikMobileInput
                                                    value={formikProps && formikProps.values.dob}
                                                    onChange={async (val) => {
                                                        await formikProps.setFieldValue(
                                                            "dob",
                                                            val.value,
                                                        );
                                                        formikProps.setFieldTouched("dob");
                                                    }}
                                                    formEl={formEl}
                                                    errors={formikProps.errors}
                                                    touched={formikProps.touched}
                                                />
                                            ) : (
                                                <FormikInput
                                                    formEl={formEl}
                                                    errors={formikProps.errors}
                                                    touched={formikProps.touched}
                                                />
                                            )}
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div>
                <div className="mb-3 d-lg-none">
                    <Hr />
                </div>
                <SubmitControls cancelHandler={this.toggleEditBasicInfo} />
            </Form>
        );
    };

    alteredFormData = (data) => {
        let alteredData = { ...data };

        let DOBnumber = {
            dob: alteredData.dob,
        };

        DOBnumber = {
            dob: `${DOBnumber.dob.substring(0, 2)}/${DOBnumber.dob.substring(
                2,
                4,
            )}/${DOBnumber.dob.substring(4, 8)}`,
        };
        return DOBnumber;
    };

    trasformDOBsToValidStrings = (data) => {
        let updatedData = { ...data };
        if (updatedData.hasOwnProperty("dob")) {
            updatedData["dob"] = updatedData["dob"].replace(/\//g, "");
        }

        return updatedData;
    };

    submitHandler = (formData, action) => {
        let newFormData = { ...formData };
        if (isUserAdmin()) {
            let newDOBData = this.alteredFormData(formData);
            newFormData.dob = newDOBData.dob;
        }
        let data = { ...newFormData };
        this.setState((ps) => {
            return {
                editableProfileData: null,
                edit: !ps.edit,
            };
        });
        this.props.submit(data, action);
    };

    render = () => {
        let validationSchema = VALIDATION_SCHEMA;
        if (!isUserAdmin()) {
            validationSchema = PATIENT_VALIDATION_SCHEMA;
        }
        return (
            <PatientProfileDetailsCard
                onclick={this.toggleEditBasicInfo}
                edit={this.state.edit}
                heading="Basic Information"
                type={"Edit"}
                isEditable
                classes={this.props.classes}>
                <div className="PatientProfile__basic-info no-gutters row pt-2">
                    {!this.state.edit &&
                        iterableBasicInfo(this.props.data).map((item) => {
                            return (
                                <div key={item.title} className="col-12 col-lg-6">
                                    {renderTitleWithValue(
                                        item.title,
                                        item.value,
                                        item.subtitle,
                                        item.optional,
                                    )}
                                </div>
                            );
                        })}
                    {this.state.edit && (
                        <CustomForm
                            initialValues={this.state.editableData}
                            validationSchema={validationSchema}
                            onSubmit={this.submitHandler}
                            render={this.renderBasicForm}
                        />
                    )}
                </div>
            </PatientProfileDetailsCard>
        );
    };
}

export default ProfileBasicInfo;

export const iterableBasicInfo = (profileData) => [
    { title: "Legal First Name", value: profileData.first_name || "" },
    { title: "Legal Last Name", value: profileData.last_name || "" },
    {
        title: PREFERRED_NAME_SCHEMA_PATIENT.elementConfig.label,
        value: profileData.preferred_name || "",
        subtitle: PREFERRED_NAME_SCHEMA_PATIENT.elementConfig.subtext,
        optional: true,
    },
    { title: "Preferred Pronouns", value: profileData.preferred_pronouns || "", optional: true },
    { title: "Date of Birth", value: profileData.dob || "" },
    { title: "Gender", value: profileData.gender || "" },
    { title: "Mobile", value: profileData.mobile || "" },
    { title: "Email", value: profileData.email || "" },
    { title: "Street", value: profileData.address.street || "" },
    { title: "State", value: profileData.address.state || "" },
    { title: "City", value: profileData.address.city || "" },
    { title: "Zip", value: profileData.address.zip_code || "" },
];
